import { render, staticRenderFns } from "./appointmentRecord.vue?vue&type=template&id=66aaff1c&scoped=true"
import script from "./appointmentRecord.vue?vue&type=script&lang=js"
export * from "./appointmentRecord.vue?vue&type=script&lang=js"
import style0 from "./appointmentRecord.vue?vue&type=style&index=0&id=66aaff1c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66aaff1c",
  null
  
)

export default component.exports